import { Control, Controller } from "react-hook-form";

import { RelevanceScoreButtons } from "../../form_components/RelevanceScoreButtons";
import { SignalSelect } from "../../form_components/SignalSelect";
import { NoticeFilters } from "../utils";

import css from "./Signals.module.scss";

export interface SignalsFilterContentProps {
  control: Control<NoticeFilters, unknown>;
}

function SignalsFilterContent({ control }: SignalsFilterContentProps) {
  return (
    <div className={css.filterSection} aria-label="Signals filters">
      <SignalSelect
        name="signals"
        label="Signals"
        control={control}
        placeholder="Select..."
        allowClear
        hideLabel
      />
      <Controller
        name="relevanceScore"
        control={control}
        render={({ field }) => (
          <div className={css.inputContainer}>
            <label htmlFor="relevanceScore" className={css.inputLabel}>
              <h3>Signal score</h3>
            </label>
            <RelevanceScoreButtons {...field} entityType="notice" />
          </div>
        )}
      />
    </div>
  );
}

export default SignalsFilterContent;
